import React from 'react';
import TabPanel from '@mui/lab/TabPanel';
function TabPaneles({ value, index, children }) {
  return (
    <TabPanel value={value} index={index} style={{paddingLeft: '0', paddingRight: '0'}}>
      {children}
    </TabPanel>
  );
}

export default TabPaneles;